import "./service.css"
import { useScroll, motion, useSpring, useTransform } from "motion/react";
import PopForm from "../components/popForm";
import { useEffect, useState } from "react";

export default function ServiceGold(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    const {scrollY} = useScroll()
    const rotate = useTransform(
      scrollY,
      [0, 300],
      [0, 310],
      { clamp: false }
    )

    const [pop, setPop] = useState(sessionStorage.getItem('pop'))
    const closePop = ()=>{
    sessionStorage.setItem('pop', true);
    setPop(true)
    }
    return(
        <>
        <section className="container serviceLanding">
            <h2>Gold<br/> Services</h2>        
        </section>
        <div className="wrapper">
            <section className="container serviceContainer">
                <header>
                    <figure className="serviceFlower">
                        <img src="../images/flower_2.png" alt="flower"/>
                    </figure>
                    <h3>Aurum Gold Company</h3>
                    <p>offers instant spot cash for gold, silver, or diamond jewelry. Selling gold is easy and fast, visit our nearest branch to avail the best price for your gold now.</p>
                </header>
                <main>
                    <div className="service">
                        <h3>Release Pledged Gold</h3>
                        <figure>
                            <img src="../images/pledge.png" alt="pledge"/>
                        </figure>
                        <p>Releasing pledged gold from Banks, Financiers, and Pawn brokers, The benefit of releasing pledged gold and selling to receive enough cash amount before it gets delayed and your interest rates start to touch the skies. Customers can visit any of our below-listed branches.</p>
                    </div>

                    <div className="service">
                        <h3>Sell Gold</h3>
                        <figure>
                            <img src="../images/sell.png" alt="sell"/>
                        </figure>
                        <p>To Sell gold Additionally a jewelry buyer will estimate your gold. They’re sure to exchange your adornments, so within the event that you simply have an honest piece that will have included an incentive for its appearance then you’ll believe in utilizing Jewelry buyers. In any event, you’ll believe utilizing a goldsmith to urge an examination of your gold pieces. </p>
                    </div>

                    <div className="service">
                        <h3>Close Gold Loan</h3>
                        <figure>
                            <img src="../images/Close.png" alt="Close"/>
                        </figure>
                        <p>Attica Gold helps customers to Close Gold Loan by releasing customers gold loan with Attica Gold money and pay the balance to customers if any.</p>
                    </div>

                    <div className="service">
                        <h3>Re-pledge Gold</h3>
                        <figure>
                            <img src="../images/Re-pledge.png" alt="Re-pledge"/>
                        </figure>
                        <p>Aurum Gold Compnay will provide cash to advance your secured gold loan. We go to the place with our customers and pay the required amount to get the pledged gold released. We confirm the purity of the gold once it has been released and pay the release fee and RePledge the gold at Aurum Gold Company at given market value.</p>
                    </div>

                    <div className="service">
                        <h3>Transfer Gold Loan</h3>
                        <figure>
                            <img src="../images/Transfer.png" alt="Transfer"/>
                        </figure>
                        <p>At Aurum Gold Company we release high interest rate Vendors and transfer to other Vendors as per convinced</p>
                    </div>

                    <figure className="serviceDecor_1">
                        <motion.img
                        id="scroll-indicator"
                        style={{
                            rotate
                        }}
                        src="../images/shape_1.png" alt="shape"/>
                    </figure>
                </main>
            </section>
        </div>
        {pop?null:<PopForm close={closePop}/>}
        </>
    )
}